// Laden der notwendingen Pakete/Abhängigkeiten
import Draw from 'ol/interaction/Draw';
import Modify from 'ol/interaction/Modify';
import GeoJSON from 'ol/format/GeoJSON';
import { getUid } from 'ol/util';
import { survSource, survSourceTemp } from './background_map';
import { toast } from 'bulma-toast'
import { map } from './map';
import { unID } from './surv';


// Variablen definieren
let draw, snap, modify;
let feature;
let geojsonStr = {};


const url_mapsurv_sqlite = 'http://localhost:8082';
//"Interaktionen"
const typeSelect = document.getElementById('draw_type');
const modPop = document.getElementById("modal_popup");
const survSave = document.getElementById("save_geo_surv");
const switchDel = document.getElementById("switch_del");
const switchModi = document.getElementById("switch_modi");
// Umfrage
const q1_geo = document.getElementById("q1_geo");
const q2_geo = document.getElementById("q2_geo");
const q3_geo = document.getElementById("q3_geo");
const q4_geo = document.getElementById("q4_geo");
const geom_surv = document.getElementById("geom_surv");
const geo_obj = document.getElementById("geo_obj");

// ---------------------------------------------------------------
// Sobald eine andere Geometrie ausgewählt wurde ....

typeSelect.onchange = function () {
    //Anmerkung: Die Variablien von typeSelect müssten konsequenterweise wie IDs  z.B. non_val geschrieben werden;
    //           Um nicht absehbare Fehler zu vermeiden wurde hier die falsche/fehlerhafte Konvention behalten.

    let value = typeSelect.value;

    // ... erzeuge eine 'freie' Karte
    removeInteractions();
    survSourceTemp.clear();

    if (value !== 'NonVal') {
        //...setze einen Cookie für die Geometrie und die benutzende Person
        postIdGeom(value);
        //... deaktiviere andere Buttons
        switchDel.disabled = true;
        switchModi.disabled = true;
        //... aufräumen des Umfrage Modals
        clearModal();
        //... erzeugen & hinzufügen eines Draws je nach Geometrietyp
        draw = createDraw(value);
        map.addInteraction(draw);
        //... notieren von Veränderungen oder der Erzeugung neuer Features
        survCreate();
    } else {
        console.log("Keine Geometrie zeichnen")
        resetSwitches();
    };
};

// ---------------------------------------------------------------
// Aussehen der Draws verändern
const styles = {
    Point: {
        'circle-radius': 5,
        'circle-fill-color': 'grey',
    },
    LineString: {
        'circle-radius': 5,
        'circle-fill-color': 'grey',
        'stroke-color': 'grey',
        'stroke-width': 3,
    },
    Polygon: {
        'circle-radius': 5,
        'circle-fill-color': 'grey',
        'stroke-color': 'grey',
        'stroke-width': 3,
        'fill-color': 'grey',
    },
};

// ---------------------------------------------------------------
// Je nach ausgewählter Geometrie wird ein Draw erstellt
function createDraw(value) {
    if (value == 'NonVal') {
        removeInteractions();
        return console.log("NonVal")
    } else if (value == 'Point') {
        draw = new Draw({
            source: survSourceTemp,
            type: typeSelect.value,
            style: styles[value],
        });
        return draw

    } else if (value == 'LineString') {
        draw = new Draw({
            source: survSourceTemp,
            type: typeSelect.value,
            style: styles[value],
        });
        return draw
    } else if (value == 'Polygon') {
        draw = new Draw({
            source: survSourceTemp,
            type: typeSelect.value,
            style: styles[value],
        });
        return draw
    }
};
// ---------------------------------------------------------------
//Verändern
switchModi.onchange = function () {
    if (switchModi.checked) {
        switchDel.disabled = true;
        typeSelect.disabled = true;
        removeInteractions();
        clearModal();
        modify = new Modify({
            source: survSource
        });
        map.addInteraction(modify);

    } else if (switchModi.checked === false) {
        resetSwitches();
    }
};

// ---------------------------------------------------------------
//Löschen
switchDel.onchange = function () {
    if (switchDel.checked) {
        console.log("delete")
        switchDel.disabled = false;
        typeSelect.disabled = true;
        switchModi.disabled = true;
        removeInteractions();

    } else if (switchDel.checked === false) {
        console.log("not delete")
        resetSwitches();
    }
};

// ---------------------------------------------------------------
// Öffnen des Modals ermöglichen
function survClick(map, e) {

    feature = map.forEachFeatureAtPixel(e.pixel, (f, layer) => {
        try {
            f.layerId = layer.get("id");
            return f;
        } catch (err) { }
    });

    if (feature) {
        if (feature.layerId == "survLayer") {
            if (switchModi.checked) {
                updateSurv(feature);
            } else if (switchDel.checked) {
                deleteSurv(feature);
            } else {
                showModal(feature);
            }
        }
    }
};

// einziger Export
export { survClick };

// ---------------------------------------------------------------
// Notieren von Veränderungen oder der Erzeugung neuer Features
function survCreate() {

    // nach dem Beenden des Zeichnens eines Objektes
    draw.on('drawend', (e) => {
        map.removeInteraction(draw);
        let f = e.feature;

        // Erzeugung eines neuen Features als GeoJson
        let writer = new GeoJSON();
        geojsonStr = writer.writeFeature(f);
        geom_surv.value = geojsonStr;
        geo_obj.value = getUid(f) + unID
        //geo_obj.value = String(getUid(f)) + unID

        // Modal aktivieren
        modPop.classList.add('is-active');
        // Knöpfe zurücksetzen
        resetSwitches();
    }, this);


    modify = new Modify({
        source: survSourceTemp
    });
    map.addInteraction(modify);

    // nach dem Ändern
    modify.on('modifyend', (e) => {
        let f = e.feature.item(0);
        console.log("Modify ID", f.getId())
        let writer = new GeoJSON();
        geojsonStr = writer.writeFeature(f);
        geom_surv.value = geojsonStr;
        console.log("Modify: ", geom_surv.value);

    });
};

// ---------------------------------------------------------------
// Schreiben in die Datenbank nach "click" auf Speichern
survSave.addEventListener("click", (e) => {
    e.preventDefault();

    //Zielurl definieren
    let url;
    if (typeSelect.disabled === true) {
        url = url_mapsurv_sqlite + '/updateGeo';
    } else if (typeSelect.disabled === false) {
        url = url_mapsurv_sqlite + '/createGeo';
    }


    // Zu speicherende Informationen ziehen und formatieren
    let data = JSON.parse(geom_surv.value);
    let geoObj = geo_obj.value
    let geoId = geoObj.slice(0, 3);
    data.properties = {
        "id": unID,
        "geo_id": geoId,
        "geo_obj": geoObj,
        "q1_geo": q1_geo.value,
        "q2_geo": q2_geo.value,
        "q3_geo": q3_geo.value,
        "q4_geo": q4_geo.value,

    };
    console.log("Data: ", data);

    // Senden an die Datenbank...
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/geo+json; charset=utf-8;',
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        // ... falls erfolgreich Rückmeldung
        .then(data => {
            const delMes = toast({
                message: data.message,
                type: 'is-success',
                position: 'bottom-right',
                pauseOnHover: true,
                duration: 8000,
                dismissible: true,
            })

            //... wenn die Geometrieauswahl nicht deaktiviert ist und die Daten übertragen worden sind; Laden wir die Nutzenden Geometrien
            if (typeSelect.disabled === false && data.status) {
                loadUserTotal();
            }

        })
        // ... falls nicht erfolgreich Rückmeldung
        .catch((error) => {

            const saveMes = toast({
                message: error.message,
                type: 'is-danger',
                position: 'bottom-right',
                pauseOnHover: true,
                duration: 8000,
                dismissible: true,
            });
        });

    removeInteractions();
    resetSwitches();
});


// ---------------------------------------------------------------
// zurücksetzen des Geo Modals
function clearModal() {
    q1_geo.selectedIndex = 0;
    q2_geo.selectedIndex = 0;
    q3_geo.selectedIndex = 0;
    q4_geo.value = "";
    geom_surv.selectedIndex = 0;
};

// ---------------------------------------------------------------
// Interaktionen deaktivieren
function removeInteractions() {
    map.removeInteraction(draw);
    map.removeInteraction(snap);
    map.removeInteraction(modify);
}

// ---------------------------------------------------------------
// Cookies speichern
function postIdGeom(value) {
    console.log("Cookiewerte für ID + GeomType: ", unID, value);
    let data = {
        "id": unID,
        "geom_type": value
    }
    document.cookie = "user_id=" + unID + "; SameSite=None; Secure"
    document.cookie = "geom_type=" + value + "; SameSite=None; Secure";
};


// ---------------------------------------------------------------
// Laden der Nutzenden Informationen

function loadUserTotal() {
    // Leeren des Layers
    survSource.clear()
    //Anfrage an Datenbank
    fetch(url_mapsurv_sqlite + '/get', {
        method: 'GET',
        credentials: "include",


    })
        // Benachrichtigung bei Fehler
        .then(response => {
            if (!response.ok) {
                throw new Error('Fehler bei der Serververbindung');
            }
            return response.json();
        })
        // Bauen eines GeoJsons für die jeweiligen Nutzenden
        .then(data => {

            const nGeoJSON = new GeoJSON();
            const features = nGeoJSON.readFeatures(data);
            let geo_obj;
            for (let i = 0; i < features.length; i++) {
                geo_obj = features[i].get("geo_obj");
                features[i].setId(geo_obj);
            };
            survSource.addFeatures(features);
            survSourceTemp.clear();
        })
        .catch(error => {
            console.error('Es gab einen Fehler:', error.message);
        });
};

// ---------------------------------------------------------------
// Bei Klick auf Geometrie werden die jeweiligen Daten geladen
function showModal(feature) {
    let writer = new GeoJSON();
    let geojsonStr = writer.writeFeature(feature);
    q1_geo.value = feature.get("q1_geo");
    q2_geo.value = feature.get("q2_geo");
    q3_geo.value = feature.get("q3_geo");
    q4_geo.value = feature.get("q4_geo");
    geom_surv.value = geojsonStr;
    survSave.disabled = true;
    modPop.classList.add('is-active');
};

// ---------------------------------------------------------------
// Löschen aus der Datenbank
function deleteSurv(f) {
    try {
        // Objekt wählen
        let fid = f.id_;
        let id = f.get("id");
        console.log("DELETE; ID: ", id, "FID: ", fid);
        survSource.removeFeature(f);

        // Datenbankanfrage
        fetch(url_mapsurv_sqlite + '/delete', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({ "obj_id": fid, "id": id })
        })
            .then(response => response.json())
            .then(data => {
                const saveMes = toast({
                    message: data.message,
                    type: 'is-success',
                    position: 'bottom-right',
                    pauseOnHover: true,
                    duration: 5000,
                    dismissible: true,
                })

            })
            .catch(error => {
                const saveMes = toast({
                    message: error.message,
                    type: 'is-danger',
                    position: 'bottom-right',
                    pauseOnHover: true,
                    duration: 5000,
                    dismissible: true,
                });
            });
    } catch (error) { }
};

// ---------------------------------------------------------------
// Zurücksetzen der Buttons
function resetSwitches() {
    typeSelect.selectedIndex = 0;
    switchDel.disabled = false;
    switchModi.disabled = false;
    switchModi.checked = false;
    typeSelect.disabled = false;
    survSave.disabled = false;
};

// ---------------------------------------------------------------
// Und einfache Updaten ermöglichen
function updateSurv(feature) {
    survSave.disabled = false;
    modPop.classList.add('is-active');
    let f = feature;
    let writer = new GeoJSON();
    geojsonStr = writer.writeFeature(f);
    geom_surv.value = geojsonStr;

    modify.on('modifyend', function (e) {
        updateSurv(f);
    });
};